<template>
  <div class="tail">
    <div class="tail_top">
      <div class="one">
        <div class="text">关于岳泰兴</div>
        <div class="border_"></div>
        <div class="title">
          岳泰兴医疗科技成立于2017年，是一家致力于通过互联网、云计算、A等高新技术，专注于医疗大健康科技研发的专精特新企业。
        </div>
<!--        <div class="img_list">-->
<!--          <div class="image" @click="goToLx"><img src="/status/contact-1.png"></div>-->
<!--          <div class="image" @click="goToLx"><img src="/status/contact-2.png"></div>-->
<!--          <div class="image" @click="goToLx"><img src="/status/contact-3.png"></div>-->
<!--          <div class="image" @click="goToLx"><img src="/status/contact-4.png"></div>-->
<!--        </div>-->
      </div>
<!--      <div class="yqlj">-->
<!--        <div class="text">友情链接</div>-->
<!--        <div class="border_"></div>-->
<!--        <div class="title_list">-->
<!--          <div class="title_info" @click="goToDingwei">-->
<!--            顶卫云科技-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="two">-->
<!--        <div class="text">快速链接</div>-->
<!--        <div class="border_"></div>-->
<!--        <div class="title_list">-->
<!--          <div class="title_info" v-for="(item,index) in titleList" :key="index" @click="selectMenu(item)">-->
<!--            {{item.title}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="three">-->
<!--        <div class="text">产品分类</div>-->
<!--        <div class="border_"></div>-->
<!--        <div class="title_list">-->
<!--          <div class="title_info" v-for="(item,index) in productClassificationList" :key="index">-->
<!--            {{item}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="yqlj">
        <div class="text">联系我们</div>
        <div class="border_"></div>
        <div class="title_list">
          <div class="title_info" @click.prevent.stop="makeCall">
            <img style="width: 50px" src="/intelligentGuidance/20.png">
            咨询电话：400-022-9558
          </div>
          <div class="title_info" style="cursor: pointer" @click="goToDingwei">
            <img src="/intelligentGuidance/21.png">
            官网网址：www.yuetaixing.com
          </div>
          <div class="title_info">
            <img src="/intelligentGuidance/22.png">
            邮箱：yuetaixing668@163.com
          </div>
          <div class="title_info">
            <img src="/intelligentGuidance/23.png">
            公司地址：长沙市雨花区158号
          </div>
        </div>
      </div>
      <div class="fore">
        <img src="/status/footer_erweima.b7ef9d94.png">
        <div class="title">扫一扫，关注微信公众号</div>
      </div>
    </div>

    <div class="tail_bottom">
      湖南岳泰兴医疗科技有限公司
      <a style="color: rgb(238,216,38);text-decoration: none;" href="https://beian.miit.gov.cn/" target="_blank">湘ICP备19022900号-1</a>
    </div>
  </div>
</template>

<script>
import {productClassificationList} from '@/views/mock'
export default {
  name: "tail_menu",
  data(){
    return{
      phoneNumber:'400-022-9558',
      titleList: [
        {title: '首页', url: 'index'},
        {title: '品牌理念', url: 'brandConcept'},
        {title: '企业资讯', url: 'enterpriseInformation'},
        {title: '商务合作', url: 'businessCooperation'},
        {title: '核心产品', url: 'coreProduct'},
        {title: '人才招聘', url: 'talentRecruitment'},
        {title: '联系我们', url: 'contactUs'},
      ],
      productClassificationList:productClassificationList,
    }
  },
  methods: {
    makeCall() {
      window.location.href = `tel:${this.phoneNumber}`;
    },
    goToDingwei(){
      window.open('https://www.yuetaixing.com/')
    },
    selectMenu(item, index) {
      let params = {};
      if(item.url == 'coreProduct'){
        params = {fid:0}
      }else {
        params = {}
      }
      this.$router.push({name: item.url,query:params});
    },
    goToLx(){
      this.$router.push({name: 'contactUs'});
    }
  }
}
</script>

<style scoped lang="scss">
.tail_top{

  padding: 80px 50px 360px 50px;
  background: rgb(74,123,172);
  color: white;
  display: flex;
  justify-content: space-between;
  position: relative;
  .yqlj{
    .title_list{
      font-size: 44px;
      .title_info{
        margin-top: 34px;
        display: flex;
        align-items: center;
        img{
          width: 50px;
          margin-right: 6px;
        }
      }

    }
  }
  .text{
    font-size: 62px;
    font-weight: bold;
  }
  .border_{
    width: 100px;
    border: 2px solid white;
    margin-top: 14px;
  }
  .one{
    max-width: 700px;
    .img_list{
      margin-top: 30px;
      display: flex;
      align-items: center;
      .image{
        background: rgb(125,157,193);
        width: 46px;
        height: 46px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        border-radius: 100%;
        img{
          width: 14px;
          cursor: pointer;
        }
      }

    }
  }
  .two{
    .title_list{
        font-size: 44px;
      .title_info{
        margin-top: 14px;
        cursor: pointer;
      }

    }
  }
  .three{
    .title_list{
      font-size: 34px;
      .title_info{
        margin-top: 14px;
      }

    }
  }
  .one,.two,.three{
    .title{
      margin-top: 14px;
      font-size: 42px;
    }
  }

  .fore{
    position: absolute;

    display: flex;
    margin-top: 400px;
    margin-left: 100px;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
    font-size: 34px;
    img{
      width: 300px;
      margin-bottom: 14px;
    }
  }
}
.tail_bottom{
  background: rgb(48,91,128);
  text-align: center;
  color: white;
  padding: 50px;
  font-size: 34px;
}
</style>
